export const isPhoneJs = () => {
  return window.matchMedia("(max-width: 425px)").matches;
};
